import React from 'react';
import { withRouter } from 'react-router-dom';
import KenTable from '../../global_components/KenTable/kentable';
import KenPaginationUI from '../../global_components/KenPaginator';
import GetAppIcon from '@material-ui/icons/GetApp';
// import pdf from './Demo Employee -OCT 2020 Salary Slip.pdf';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import logoImg from '../../Assets/ken42-logo.jpg';
import './index.scss';
const monthPayslipDetails = require('./payslip.json');
class MyPayslips extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            monthPayslipDetails: [],
            noProg: 'Fetching Details..',
            monthName: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            loader: false,
            page: 1,
            limit: 10,
            totalRecord: 0,
            totalPages: 1,
            tabview: false,
            institudeDetails:{}
        }
    }
    async componentDidMount() {
        // this.setState({ loader: true }, () => {
        //     axios.get(`${this.state.env['zqBaseUri']}/setup/payrollsettings?instituteid=${this.state.orgId}`, {
        //         headers: {
        //             'Authorization': this.state.authToken
        //         }
        //     }).
        //         then(async res => {
        //             console.log(res)
        //             if (res.data.length !== 0) {
        //                 let response = res.data
        //                 let baseLogo = response[0].logo["logo"] !== "" ? response[0].logo["logo"] : undefined;
        //                 this.setState({ institudeDetails: response[0]['instituteDetails'] });
        //                 this.setState({ logo: undefined, logoLoaded: true, loader: false }, () => {
        if (this.props.location.state != undefined || this.props.employeeDetails != undefined) {
            let ed = this.props.employeeDetails != undefined ? this.props.employeeDetails : this.props.location.state.employeeDetails
            let pd = this.props.payslipDetails != undefined ? this.props.payslipDetails : this.props.location.state.payslipDetails
            if (ed != undefined && pd != undefined) {
                this.setState({
                    tabview: false,
                    employeeDetails: ed, logoLoaded: true
                }, () => {
                    let payslipDetails = pd
                    let earnArray = [
                        {
                            "name": "Gross Salary",
                            "amount": payslipDetails.totalEarnings
                        }
                    ]

                    // let deductionKeys = ["Professional Tax", "Provident Fund Employee's contribution", "TDS", "LIC SSS", "General Insurance", "Health Insurance", "Salary Advance", "F.A.", "Bus Fare", "Caution Deposit", "Misc."]
                    let earningsData = this.props.earningData != undefined ? this.props.earningData : this.props.location.state.earningData
                    let deductionsData = this.props.deductionData != undefined ? this.props.deductionData : this.props.location.state.deductionData
                    if (earningsData.length < deductionsData.length) {
                        let remainEarning = deductionsData.length - earningsData.length
                        for (let i = 0; i < remainEarning; i++) {
                            earnArray.unshift(
                                {
                                    "name": "",
                                    "amount": null
                                }
                            )

                        }
                    }
                    let deductArray = [
                        {
                            "name": "Total Deductions",
                            "amount": payslipDetails.totalDeductions
                        }

                    ]
                    let deductionData = []
                    // deductionKeys.map(deductionKey => {
                    deductionsData.map(deductionItem => {
                        console.log('deductionItem', deductionItem)
                        // if (String(deductionKey).toLowerCase() == String(deductionItem.name).toLowerCase() || String(deductionKey).toLowerCase() == String(deductionItem.description).toLowerCase()) {
                        deductionItem['name'] = deductionItem.name == "Misc." ? "Miscellaneous" : deductionItem.description == "General Insurance" ? "GSLIS" : deductionItem.name == "Provident Fund Employee's contribution" ? "EPF" : deductionItem.name
                        deductionData.push(deductionItem)
                        // }
                    })
                    //     if (String(deductionKey).toLowerCase() == "spl adv") {
                    //         deductionData.push(
                    //             {
                    //                 "name": "Deposit",
                    //                 "amount": null
                    //             }
                    //         )
                    //     }
                    // })

                    if (earningsData.length > deductionsData.length) {
                        let remainEarning = deductionsData.length - earningsData.length
                        for (let i = 0; i < remainEarning; i++) {
                            deductArray.unshift(
                                {
                                    "name": "",
                                    "amount": null
                                }
                            )

                        }
                    }
                    let earnList = earningsData.concat(earnArray)
                    let deduList = deductionData.concat(deductArray)
                    let Month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    let monthName = ''
                    if (isNaN(payslipDetails.processingMonth)) {
                        monthName = payslipDetails.processingMonth
                    }
                    else {
                        monthName = Month[payslipDetails.processingMonth - 1]
                    }
                    let PR = String(payslipDetails.jobType).toLowerCase() != "teaching" ? "100%" : Math.round(payslipDetails.payoutRatio) <= 50010 ? "100%" : "75%"
                    this.setState({
                        Earnings: earnList,
                        Deductions: deduList,
                        processingMonth: monthName,
                        netSalaryPayable: payslipDetails.netSalaryPayable,
                        payoutRatio: payslipDetails.payoutRatio,
                        totalDeduction: payslipDetails.totalDeductions,
                        grossSalary: payslipDetails.totalEarnings,
                        salaryPayable: payslipDetails.salaryPayable,
                        tabview: false, preview: true,
                        payslipDetails: payslipDetails,
                        // monthSalaryProcessDetails: this.props.monthSalaryProcessDetails != undefined ? this.props.monthSalaryProcessDetails:this.props.location.state.monthSalaryProcessDetails

                    }, () => {
                        this.setState({ detailsFetched: true, loader: false })
                    });
                })
            }
        } else {
            this.setState({ tabview: true, logoLoaded: true })
            // axios.get(`${this.state.env['baseUri']}/user/profile?userName=${this.state.loginEmail}`, {
            //     headers: {
            //         'Authorization': this.state.authToken
            //     }
            // }).
            //     then(async userRes => {
            //         console.log('userRes', userRes)
            //         axios.get(`${this.state.env['zqBaseUri']}/payroll/employeewisePayslip/${this.state.orgId}/${userRes.data.data.employeeID}`,
            //             {
            //                 headers: {
            //                     'Authorization': this.state.authToken
            //                 }
            //             })
            //             .then((resp) => {
            //                 console.log('response', resp)
            //                 var response = resp.data.data
            var response = monthPayslipDetails.data
            let employeeDetails = []
            response.map(item => {
                var transDate = new Date(item.transactionDate)
                console.log('item.payoutRatio', item.payoutRatio)
                // if (item.payoutRatio == "100%" && item.email.length > 1) {
                console.log('item entered', item.payoutRatio)
                let Month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                let monthName = ''
                if (isNaN(item.processingMonth)) {
                    monthName = item.processingMonth
                }
                else {
                    monthName = Month[item.processingMonth - 1]
                }
                employeeDetails.push({
                    // 'Employee ID': item.employeeId,
                    // "Name": item.salutation + item.firstName + item.lastName,
                    'Year': item.processingYear,
                    'Month': monthName,
                    'Salary Received': this.formatCurrency(Number(item.salaryPayable)),
                    'Salary Date': `${transDate.getDate()}/${String(transDate.getMonth() + 1).length == 1 ? (0 + String(transDate.getMonth() + 1)) : (transDate.getMonth() + 1)}/${transDate.getFullYear()}`,
                    'Status': "Paid",
                    'Item': JSON.stringify(item)
                })
                // }
            })
            this.setState({ monthPayslipDetails: employeeDetails, loader: false }, () => {
                console.log('employeeDetails', this.state.monthPayslipDetails)
            })
            //                 })
            //                 .catch((err) => { this.setState({ noProg: "No Data", loader: false }) })
            //         })
        }

        //                 })

        //                 this.setState({
        //                     logo: response[0].logo["logo"] !== "" ? response[0].logo["logo"] : undefined,
        //                     institudeDetails: response[0]['instituteDetails']
        //                 })
        //             }

        //         }).catch(err => {
        //             console.log(err)
        //             this.setState({ resText: 'No Data', configInfo: false, })
        //         }
        //         )
        // })

    }
    onPreviewEmployees = (item) => {
        console.log(item)
        // this.setState({ tabview: false, preview: true })
        this.setState({ payslipDetails: undefined }, () => {
            let payslipDetails = JSON.parse(item.Item)
            let earnArray = [
                {
                    "name": "Gross Salary",
                    "amount": payslipDetails.totalEarnings
                }
            ]

            let deductionKeys = ["Professional Tax", "Provident Fund Employee's contribution", "TDS", "LIC SSS", "General Insurance", "Health Insurance", "Salary Advance", "F.A.", "Bus Fare", "Caution Deposit", "Misc."]
            if (payslipDetails.earnings.length < payslipDetails.deductions.length) {
                let remainEarning = payslipDetails.deductions.length - payslipDetails.earnings.length
                for (let i = 0; i < remainEarning; i++) {
                    earnArray.unshift(
                        {
                            "name": "",
                            "amount": null
                        }
                    )

                }
            }
            let deductArray = [
                {
                    "name": "Total Deductions",
                    "amount": payslipDetails.totalDeductions
                }

            ]
            let deductionData = []
            // deductionKeys.map(deductionKey => {
            payslipDetails.deductions.map(deductionItem => {
                console.log('deductionItem', deductionItem)
                // if (String(deductionKey).toLowerCase() == String(deductionItem.name).toLowerCase() || String(deductionKey).toLowerCase() == String(deductionItem.description).toLowerCase()) {
                deductionItem['name'] = deductionItem.name == "Misc." ? "Miscellaneous" : deductionItem.description == "General Insurance" ? "GSLIS" : deductionItem.name == "Provident Fund Employee's contribution" ? "EPF" : deductionItem.name
                deductionData.push(deductionItem)
                // }
            })
            //     if (String(deductionKey).toLowerCase() == "spl adv") {
            //         deductionData.push(
            //             {
            //                 "name": "Deposit",
            //                 "amount": null
            //             }
            //         )
            //     }
            // })

            if (payslipDetails.earnings.length > payslipDetails.deductions.length) {
                let remainEarning = payslipDetails.deductions.length - payslipDetails.earnings.length
                for (let i = 0; i < remainEarning; i++) {
                    deductArray.unshift(
                        {
                            "name": "",
                            "amount": null
                        }
                    )

                }
            }
            let earnList = payslipDetails.earnings.concat(earnArray)
            let deduList = deductionData.concat(deductArray)
            // debugger
            let Month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            let monthName = ''
            if (isNaN(payslipDetails.processingMonth)) {
                monthName = payslipDetails.processingMonth
            }
            else {
                monthName = Month[payslipDetails.processingMonth - 1]
            }
            let PR = String(payslipDetails.jobType).toLowerCase() != "teaching" ? "100%" : Math.round(payslipDetails.payoutRatio) <= 50010 ? "100%" : "75%"
            this.setState({
                Earnings: earnList,
                Deductions: deduList,
                processingMonth: monthName,
                payslipDetails: JSON.parse(item.Item),
                netSalaryPayable: payslipDetails.netSalaryPayable,
                payoutRatio: payslipDetails.payoutRatio,
                totalDeduction: payslipDetails.totalDeductions,
                grossSalary: payslipDetails.totalEarnings,
                salaryPayable: payslipDetails.salaryPayable,
                tabview: false, preview: true

            }, () => {
                console.log('***STATE***', this.state)
            });
        })
    }
    onPaginationChange = (page, limit) => { }
    formatCurrency = (amount) => {
        return (new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount))
    }
    onDownloadPayslip = () => {
        this.setState({
            loader: true
        }, () => {
            const input = document.getElementById('payslip');
            console.log(input)
            let payload = {
                data: "data"
            }

            html2canvas(input)
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF();
                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = ((imgProps.height * pdfWidth) / imgProps.width);
                    pdf.addImage(imgData, 'JPEG', 10, 10, pdfWidth - 20, pdfHeight - 20);
                    // var blob = pdf.output('blob');

                    // var formData = new FormData();
                    // formData.append('file', blob);
                    // formData.append('name', `${this.state.payslipDetails.salutation}.${this.state.payslipDetails.firstName} ${this.state.payslipDetails.lastName}`)
                    // formData.append('email', this.state.payslipDetails.email);
                    // let config = {
                    //     headers: {
                    //         "Authorization": this.state.authToken,
                    //         'Content-Type': 'multipart/form-data'
                    //     }
                    // }
                    // axios.post(`${this.state.env['zqBaseUri']}/payroll/sendPayslip`, formData, config)
                    //     .then(response => {
                    //         console.log('response')
                    //         this.setState({ loader: false })
                    //     })
                    pdf.save(`${this.state.payslipDetails.salutation == "-" ? "" : this.state.payslipDetails.salutation + "."}${this.state.payslipDetails.firstName} ${this.state.payslipDetails.lastName} ${this.state.processingMonth + ' ' + this.state.payslipDetails.processingYear} Salary Slip.pdf`);
                    if (this.props.location.state != undefined) {
                        this.setState({ loader: false })
                    } else {
                        this.setState({ loader: false, tabview: true, payslipDetails: undefined })
                    }

                })
        })

    }
    onDateConvert = (date) => {
        return `${new Date(date).getDate()}-${new Date(date).getMonth() + 1}-${new Date(date).getFullYear()}`
    }
    render() {
        return (
            <div className="payslip-wrap">
                {this.state.tabview ?
                    <React.Fragment><div className="table-wrapper" style={{ marginTop: "10px" }}>
                        {this.state.monthPayslipDetails.length == 0 ? <p className="noprog-txt">{this.state.noProg}</p> : <React.Fragment>
                            <div className="remove-last-child-table remove-last-col" >
                                <KenTable data={this.state.monthPayslipDetails} rowClick={(item) => { this.onPreviewEmployees(item) }} />
                            </div> </React.Fragment>}
                        {this.state.monthPayslipDetails.length !== 0 && <KenPaginationUI total={this.state.totalRecords} onPaginationApi={this.onPaginationChange} totalPages={this.state.totalPages} limit={this.state.limit} />}
                    </div></React.Fragment> :
                    <div className="tab-form-wrapper tab-table ">
                        {this.state.payslipDetails != undefined && this.state.logoLoaded ?
                            <React.Fragment>
                                {(this.props.location.state != undefined || this.props.employeeDetails != undefined) ? <div className="settlement-page-wrapper ctcplan-btns" >
                                    {this.props.onReport == undefined ? <div className="trial-balance-header-title">
                                        <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.backtoEmployeeTable() }} style={{
                                            marginRight: '5px',
                                            cursor: 'pointer',
                                            marginTop: '0px'
                                        }} /> <p className="top-header-title" onClick={() => { this.backtoEmployeeTable() }}>| Processing | {this.state.processingMonth} | {this.state.payslipDetails.salutation.length > 1 ? (this.state.payslipDetails.salutation + ".") : ""}{this.state.payslipDetails.firstName} {this.state.payslipDetails.lastName}</p>
                                    </div> : this.props.onPaid != undefined ? <div className="trial-balance-header-title">
                                        <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.onback() }} style={{
                                            marginRight: '5px',
                                            cursor: 'pointer',
                                            marginTop: '0px'
                                        }} /> <p className="top-header-title" onClick={() => { this.onback() }}>| Payslip | {this.state.processingMonth} {this.state.payslipDetails.processingYear}| {this.state.payslipDetails.salutation.length > 1 ? (this.state.payslipDetails.salutation + ".") : ""}{this.state.payslipDetails.firstName} {this.state.payslipDetails.lastName}</p>
                                    </div> : <div className="trial-balance-header-title">
                                        <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.onback() }} style={{
                                            marginRight: '5px',
                                            cursor: 'pointer',
                                            marginTop: '0px'
                                        }} />
                                        <p className="top-header-title" onClick={() => { this.onback() }}>| Payslip | {this.state.payslipDetails.salutation.length > 1 ? (this.state.payslipDetails.salutation + ".") : ""}{this.state.payslipDetails.firstName} {this.state.payslipDetails.lastName}</p>
                                    </div>}
                                </div> : null}

                                <div className="preview-btns">
                                    <div>
                                        {this.props.onReport == undefined ? <button onClick={() => this.onDownloadPayslip()} className="add-item-btn payslip-btn " tooltip-title={"Download"} style={{ marginRight: "10px", marginBottom: '30px', float: 'right', width: '200px', position: "relative" }}><GetAppIcon style={{ paddingRight: "3px" }} />
                                            Download Payslip
                                        </button> : null}
                                    </div>

                                </div>
                            </React.Fragment> : null}
                        {this.state.payslipDetails != undefined && this.state.logoLoaded ?
                            <div className="show-payslips mysalay-slip-wrap" id="payslip" style={{ clear: "both" }}>
                                <div className="flex-content">
                                    <div className="payslip-logo-wrap"><img id="payslip-logo" src={`${logoImg}`} /></div>
                                    {/* <div className="payslip-logo-wrap">{this.state.logo != undefined ? <img id="payslip-logo" src={`data:image/jpeg;base64, ${this.state.logo}`} /> : null}</div> */}
                                    <div className="company-address-wrap">
                                        <h4>{this.state.institudeDetails.instituteName != undefined ? this.state.institudeDetails.instituteName : null}</h4>
                                        {String(this.state.institudeDetails.address1).length > 0 ? <h6>
                                            {this.state.institudeDetails.address1 != undefined ? `${this.state.institudeDetails.address1}${this.state.institudeDetails.address1.replace(/ /g, '').substr(this.state.institudeDetails.address1.replace(/ /g, '').length - 1) == ',' ? '' : ', '}` : null}
                                        </h6> : null}
                                        {String(this.state.institudeDetails.address2).length > 0 ? <h6>
                                            {this.state.institudeDetails.address2 != undefined ? `${this.state.institudeDetails.address2}${this.state.institudeDetails.address2.replace(/ /g, '').substr(this.state.institudeDetails.address2.replace(/ /g, '').length - 1) == ',' ? '' : ', '}` : null}
                                        </h6> : null}
                                        {String(this.state.institudeDetails.address3).length > 0 ? <h6>
                                            {this.state.institudeDetails.address3 != undefined ? `${this.state.institudeDetails.address3}${this.state.institudeDetails.address3.replace(/ /g, '').substr(this.state.institudeDetails.address3.replace(/ /g, '').length - 1) == ',' ? '' : ', '}` : null}
                                        </h6> : null}
                                        {String(this.state.institudeDetails.cityTown).length > 0 ? <h6>
                                            {this.state.institudeDetails.cityTown != undefined ? `${this.state.institudeDetails.cityTown}${this.state.institudeDetails.cityTown.replace(/ /g, '').substr(this.state.institudeDetails.cityTown.replace(/ /g, '').length - 1) == ',' ? '' : ', '}` : null} {this.state.institudeDetails.stateName != undefined ? `${this.state.institudeDetails.stateName}-${this.state.institudeDetails.pinCode}` : null}
                                        </h6> : null}
                                    </div>
                                    <div className="person-info-wrap">
                                        <div className="employee-details remove-flex">
                                            <div className="details-section1">
                                                <p className="sub-title"><b>PAN:</b><span>{this.state.institudeDetails.PAN != undefined ? this.state.institudeDetails.PAN : "-"}</span></p>
                                                <p className="sub-title"><b>TAN:</b><span>{this.state.institudeDetails.TAN != undefined ? this.state.institudeDetails.TAN : "-"}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5 style={{ textAlign: 'center', width: '100%', fontFamily: 'OpenSans-Bold', display: "flex", justifyContent: "center" }}>Payslip for the Month of {this.state.processingMonth} {this.state.payslipDetails.processingYear}</h5>
                                <div className="employee-details remove-flex">
                                    <div className="details-section1  details-section">
                                        <p className="sub-title"><b>Name of the Employee</b><span>{this.state.payslipDetails.salutation == "-" ? "" : this.state.payslipDetails.salutation + ". "}{this.state.payslipDetails.firstName} {this.state.payslipDetails.lastName == "-" ? "" : this.state.payslipDetails.lastName}</span></p>
                                        <p className="sub-title"><b>Employee ID</b><span>{this.state.payslipDetails.employeeId}</span></p>
                                        <p className="sub-title"><b>Designation</b><span>{this.state.payslipDetails.designation}</span></p>
                                        <p className="sub-title"><b>Department</b><span>{(this.state.payslipDetails.department == undefined || String(this.state.payslipDetails.department.length) == 0) ? '-' : this.state.payslipDetails.department}</span></p>
                                        <p className="sub-title"><b>Date of Joining</b><span>{String(this.onDateConvert(this.state.payslipDetails.dateOfJoining)) == 'NaN-NaN-NaN' ? '-' : this.onDateConvert(this.state.payslipDetails.dateOfJoining)}</span></p>
                                    </div>
                                    <div className="details-section2 details-section">
                                        <p className="sub-title"><b>Bank Name</b><span>{(this.state.payslipDetails.BankName == undefined || String(this.state.payslipDetails.BankName.length) == 0) ? '-' : this.state.payslipDetails.BankName}</span></p>
                                        <p className="sub-title"><b>Bank Acc. No.</b><span>{(this.state.payslipDetails.BankAcNo == undefined || String(this.state.payslipDetails.BankAcNo.length) == 0) ? '-' : this.state.payslipDetails.BankAcNo}</span></p>
                                        <p className="sub-title"><b>PAN</b><span>{(this.state.payslipDetails.PAN == undefined || String(this.state.payslipDetails.PAN.length) == 0) ? '-' : this.state.payslipDetails.PAN}</span></p>
                                        <p className="sub-title"><b>UAN</b><span>{(this.state.payslipDetails.UAN == undefined || String(this.state.payslipDetails.UAN.length) == 0) ? '-' : this.state.payslipDetails.UAN}</span></p>
                                        <p className="sub-title"><b>ESI Acc. No.</b><span>{(this.state.payslipDetails.ESIAcNo == undefined || String(this.state.payslipDetails.ESIAcNo.length) == 0) ? '-' : this.state.payslipDetails.ESIAcNo}</span></p>
                                    </div>
                                    <div className="details-section2 details-section3  details-section">
                                        <p className="sub-title"><b>Salary Month</b><span>{this.state.processingMonth + ' ' + this.state.payslipDetails.processingYear}</span></p>
                                        <p className="sub-title"><b>Working Days</b><span>{String(this.state.payslipDetails.workingDays).length == 0 ? '-' : this.state.payslipDetails.workingDays}</span></p>
                                        <p className="sub-title"><b>No. of Leaves</b><span>{String(this.state.payslipDetails.leavesTaken).length == 0 ? '-' : this.state.payslipDetails.leavesTaken}</span></p>
                                        <p className="sub-title"><b>Leaves Without Pay</b><span>{String(this.state.payslipDetails.lossOfPay).length == 0 ? '-' : this.state.payslipDetails.lossOfPay}</span></p>
                                    </div>
                                </div>
                                <div className="payslip-headings ctcHeadings">
                                    <div className="earnings-header">
                                        <h6 className="earning-lists">Earnings</h6>
                                        <div className="title-value">
                                            <div className="earn-title ctcTitle">
                                                {this.state.Earnings.map((item, idx) => {
                                                    return <input type="text" key={idx} value={item.name} style={{ fontFamily: `${(item.name == "Net Salary" || item.name == "Gross Salary") ? 'OpenSans-Bold' : 'OpenSans-Regular'}` }} className="names ctcNames" readonly />
                                                })}
                                            </div>
                                            <div className="values ctcValues">
                                                {this.state.Earnings.map((item, idx) => {
                                                    if (item.name !== "") {
                                                        return <input type="text" key={idx} value={this.formatCurrency(Number(item.amount))} style={{ fontFamily: `${(item.name == "Net Salary" || item.name == "Gross Salary") ? 'OpenSans-Bold' : 'OpenSans-Regular'}` }} className="data ctcData" readonly />
                                                    }
                                                    else {
                                                        return <input type="text" key={idx} value={item.amount} style={{ fontFamily: `${(item.name == "Net Salary" || item.name == "Gross Salary") ? 'OpenSans-Bold' : 'OpenSans-Regular'}` }} className="data ctcData" readonly />
                                                    }

                                                })}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="deductions-header">
                                        <h6 className="deduction-lists">Deductions</h6>
                                        <div className="title-value2 ctcTitle  last-earning">
                                            <div className="title2">
                                                {this.state.Deductions.map((item, idx) => {
                                                    return <input type="text" key={idx} value={item.name} style={{ fontFamily: `${(item.name == "Salary Payable" || item.name == "Total Deductions") ? 'OpenSans-Bold' : 'OpenSans-Regular'}` }} className="names ctcNames" readonly />
                                                })}
                                            </div>
                                            <div className="values2 ctcValues">
                                                {this.state.Deductions.map((item, idx) => {
                                                    if (String(item.name).toLowerCase() !== "payout ratio" && item.name !== "") {
                                                        return <input type="text" key={idx} value={this.formatCurrency(Number(item.amount))} style={{ fontFamily: `${(item.name == "Salary Payable" || item.name == "Total Deductions") ? 'OpenSans-Bold' : 'OpenSans-Regular'}` }} className="data ctcData" readonly />
                                                    }
                                                    else {
                                                        return <input type="text" key={idx} value={item.amount} style={{ fontFamily: `${(item.name == "Salary Payable" || item.name == "Total Deductions") ? 'OpenSans-Bold' : 'OpenSans-Regular'}` }} className="data ctcData" readonly />
                                                    }
                                                })}


                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className="payslip-headings ctcHeadings ctc-total-wrap" style={{
                                    marginTop: 10,
                                }}>
                                    <div className="deductions-header" >
                                        <div className="title-value2 ctcTitle  last-earning">
                                            <div className="title2">
                                                <input type="text" key={0} value={"Net Salary"} style={{ fontFamily: 'OpenSans-Bold' }} className="names ctcNames" readonly />
                                                <input type="text" key={0} value={this.formatCurrency(Number(this.state.netSalaryPayable))} style={{ fontFamily: 'OpenSans-Bold' }} className="data ctcData" readonly />
                                                <input type="text" key={1} value={"Payout Ratio"} style={{ fontFamily: 'OpenSans-Bold' }} className="names ctcNames" readonly />
                                                <input type="text" key={1} value={this.state.payoutRatio} style={{ fontFamily: 'OpenSans-Bold' }} className="data ctcData" readonly />
                                                <input type="text" key={2} value={"Salary Payable"} style={{ fontFamily: 'OpenSans-Bold' }} className="names ctcNames" readonly />
                                                <input type="text" key={2} value={this.formatCurrency(Number(this.state.salaryPayable))} style={{ fontFamily: 'OpenSans-Bold' }} style={{ fontFamily: 'OpenSans-Bold', marginRight: 0 }} className="data ctcData" readonly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="payslip-bottom-info">This is Computer Generated document. It does not require Signature.</p>
                            </div> : null
                        }
                    </div>
                }
            </div>
        )
    }
}
export default withRouter(MyPayslips);